import React, {
  useState,
  useEffect
} from 'react';

import { Form, Field } from "react-final-form";

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  CircularProgress,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import {
  FileUploadField,
  UserSelectorField
} from '../../general';

import {
  BaseAPI,
} from '../../../data/BaseAPI';

import localization from '../../../utils/localizations';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  mainGrid: {
    marginTop: 20,
  },
  gridLabelBolder: {
    textAlign: 'right',
    fontWeight: 500,
  },
  gridLabel: {
    textAlign: 'right',
    color: '#555555',
  },
  alignRight: {
    textAlign: 'right',
  },
}));

interface Values {
  title?: string;
  thesis_docx?: string;
  thesis_pdf?: string;
}

function ThesisWritingForm(props: {onSubmitted: any, onCancelled: any, values?: Values}) {
  const classes = useStyles();

  const maxUploadSize = 100*1024*1024;
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async (values: Values) => {
    if (isSaving) return;

    const api = new BaseAPI();
    setIsSaving(true);
    try {
      const [result, response, error] = await api.post(values, 's2/thesis/');
      setIsSaving(false);
  
      console.log('result', result)
      if (result.success) {
        props.onSubmitted();
      }
      else {
        return result.errors;
      }
    } catch (error) {
      setIsSaving(false);
      console.log((error as any).message, (error as any).status, (error as any).errorData);
      return (error as any).errorData;
    }

  };

  const onValidate = (values: Values) => {
    const errors: any = {}

    if (!values.title) errors.title = localization.required;
    if (!values.thesis_pdf) errors.thesis_pdf = localization.required;

    return errors;
  }

  return (
    <Form
      onSubmit={onSubmit}
      validate={onValidate}
      initialValues={props.values ? props.values : {}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} className={classes.mainGrid}>
            <Field name="title">
              {props => (
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth error={props.meta.error && props.meta.touched ? !!props.meta.error : undefined}>
                    <TextField
                      id={props.input.name}
                      label={localization.thesisTitle}
                      variant="outlined"
                      name={props.input.name}
                      value={props.input.value}
                      onChange={props.input.onChange}
                      error={(props.meta.error || props.meta.submitError) && props.meta.touched ? true: false}
                      helperText={(props.meta.error || props.meta.submitError) && props.meta.touched ? props.meta.error || props.meta.submitError : undefined}
                    />
                  </FormControl>
                </Grid>
              )}
            </Field>

            <Grid item xs={4} sm={2}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.thesis} (.docx)</Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Field name="thesis_docx">
                {props => (
                  <FileUploadField
                    accept=".docx"
                    title={localization.uploadThesis}
                    maxSize={maxUploadSize}
                    values={props.input.value}
                    fileKind="Thesis"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={2}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.thesis} (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={10}>
              <Field name="thesis_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadThesis}
                    maxSize={maxUploadSize}
                    values={props.input.value}
                    fileKind="Thesis"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={6}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                type="submit"
                disabled={isSaving}
              >Submit {localization.thesis}</Button>
              {isSaving && <CircularProgress size={20} style={{marginLeft: 10}} />}
            </Grid>
            <Grid item xs={6} className={classes.alignRight}>
              <Button
                variant="contained"
                onClick={props.onCancelled}
              >Cancel</Button>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
}

export {ThesisWritingForm};